import React from 'react';

interface AutopayConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  amountLabel: string;
  disabled?: boolean;
}

// Shared by every place that starts a paid subscription: unticked = one paid month, ticked = recurring autopay.
const AutopayConsent: React.FC<AutopayConsentProps> = ({ checked, onChange, amountLabel, disabled }) => (
  <label className="autopay-consent">
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span className="autopay-consent-text">
      <strong>Enable autopay</strong>
      <small>
        {checked
          ? `I authorize ${amountLabel} to be charged automatically every month until I cancel. You can pause or cancel anytime.`
          : `Not enabled: you pay ${amountLabel} for one month only. The plan ends after that and you renew manually.`}
      </small>
    </span>
  </label>
);

export default AutopayConsent;
